<template>
  <div
    class="sug-card"
    v-bind:class="{ done: suggestion.done }"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    @click="$emit('select')"
  >
    <div class="rank">
      <p v-if="suggestion.rank && !suggestion.done">{{ suggestion.rank }}.</p>
      <bg-icon v-else-if="suggestion.done" name="check"></bg-icon>
      <p v-else>-</p>
    </div>
    <div class="sug-text">
      <div>
        <p style="margin-bottom: 5px;">
          <b>{{ suggestion.title }}</b>
        </p>
        <p v-if="suggestion.suggestion" v-html="suggestion.suggestion"></p>
        <p v-else>-</p>
      </div>
    </div>
    <div class="effortowner" v-bind:class="{ done: suggestion.done }">
      <div class="effort" v-if="!suggestion.done">
        <p v-if="effort" :style="{ fontWeight: '600', color: effortColor }">
          {{ effort }}
          <span style="color: #141a77; font-weight: 500;">effort</span>
        </p>
        <p v-else>Effort score: -</p>
      </div>
      <div class="owner" v-if="!suggestion.done">
        <p v-if="suggestion.owner_id">@ {{ suggestion.owner }}</p>
        <p v-else style="font-size: 10pt">Owner: -</p>
      </div>
      <!-- <div v-if="suggestion.done && suggestion.suggestion.results[0]">
        <p>
          <span style="font-size: 10pt;">{{
            suggestion.results[0].metric
          }}</span
          ><br />
          <span style="font-size: 16pt; font-weight: 600;">{{
            suggestion.results[0].metric_result
          }}</span>
        </p>
      </div> -->
    </div>
    <div class="impactstep" v-bind:class="{ done: suggestion.done === true }">
      <div class="impact" v-if="!suggestion.done">
        <p v-if="impact" :style="{ fontWeight: '600', color: impactColor }">
          {{ impact }}
          <span style="color: #141a77;  font-weight: 500;">impact</span>
        </p>
        <p v-else>Impact score: -</p>
      </div>
      <div class="nextstep" v-if="!suggestion.done">
        <p v-if="suggestion.next_step" style="font-weight: 600">
          >> {{ nextStep }}
        </p>
        <div v-else>
          <p>Next step: -</p>
        </div>
      </div>
      <!-- <div v-if="suggestion.done && suggestion.results[1]">
        <p>
          <span style="font-size: 10pt;">{{
            suggestion.results[1].metric
          }}</span
          ><br />
          <span style="font-size: 16pt; font-weight: 600;">{{
            suggestion.results[1].metric_result
          }}</span>
        </p>
      </div> -->
    </div>
    <transition name="slide-fade">
      <bg-icon
        v-if="hover"
        name="chevronRight"
        style="align-self: center;"
      ></bg-icon>
    </transition>
  </div>
</template>

<style scoped lang="scss">
@import "./styles.scss";
</style>

<script>
import BgIcon from "@/components/bg-icon";
import API from "@/api";

export default {
  components: {
    BgIcon,
  },
  props: ["suggestion"],
  data() {
    return {
      hover: false,
      lowToHigh: {
        1: "Low",
        2: "Medium",
        3: "High",
      },
      effortImpactColors: {
        1: "#00DEAB",
        2: "#F1C40F",
        3: "#FF14A9",
      },
      owner: null,
    };
  },
  computed: {
    additional() {
      let string = this.suggestion.additional_info;
      let array = string.split(" ");

      if (array.length > 40) {
        string = array
          .slice(0, 40)
          .join(" ")
          .concat("...");
      }

      return string;
    },
    nextStep() {
      const steps = {
        1: "Implement",
        2: "A/B test",
        3: "Research",
        4: "Nothing",
      };
      return steps[this.suggestion.next_step];
    },
    effort() {
      return this.lowToHigh[this.suggestion.effort];
    },
    impact() {
      return this.lowToHigh[this.suggestion.impact];
    },
    effortColor() {
      return this.effortImpactColors[this.suggestion.effort];
    },
    impactColor() {
      return this.effortImpactColors[this.suggestion.impact];
    },
  },
};
</script>
